import {put, takeLatest} from "redux-saga/effects";
import AppActions from "bukku/redux/App/actions";
import {message, Modal, Table} from "antd";
import { t } from "@lingui/macro";
import React from "react";
import { capitalize } from "./Transaction/helper";

export const setRequestReducer =
    (state, statusKey, extra = {}) => ({...state, ...{[statusKey]: 'request'}, ...extra});
export const setSuccessReducer =
    (state, statusKey, extra = {}) => ({...state, ...{...extra, [statusKey]: 'success'}});
export const setErrorReducer =
    (state, statusKey, extra = {}) => ({...state, ...{[statusKey]: 'error'}, ...extra});

export const sagaReducer = (state, action, getReadStateKey) => {
    const readStateKey = getReadStateKey(action);
    if (readStateKey) {
        if (action.type.includes("_REQUEST"))
            return setRequestReducer(state, readStateKey);
        if (action.type.includes("_SUCCESS"))
            return setSuccessReducer(state, readStateKey);
        if (action.type.includes("_ERROR"))
            return setErrorReducer(state, readStateKey);
    }
    return {...state};
};

export function* requestSagaPullingFn(action, mainFn, triggerAppPulling = true) {
    const {type} = action;
    try {
        if (triggerAppPulling)
            yield put({type: AppActions.APP_START_PULLING});
        yield mainFn(action);
    }
    catch (error) {
        const errorType = type.replace("REQUEST", "ERROR");
        yield put({type: errorType, error});
    }
    finally {
        if (triggerAppPulling)
            yield put({type: AppActions.APP_STOP_PULLING});
    }
}

export function* requestSagaPushingFn(action, mainFn) {
    const {type} = action;
    try {
        yield put({type: AppActions.APP_START_PUSHING});
        yield mainFn(action);
    }
    catch (error) {
        const errorType = type.replace("REQUEST", "ERROR");
        yield put({type: errorType, error});
    }
    finally {
        yield put({type: AppActions.APP_STOP_PUSHING});
    }
}

// Success
export function successSagaFn(successKeys, getSuccessMsg) {
    return function* () {
        yield takeLatest(successKeys, function* (action) {
            const msg = getSuccessMsg(action);
            if (msg)
                yield message.success(msg);
        });
    };
}

// Error
export function errorSagaFn(errorKeys) {
    return function* () {
        yield takeLatest(errorKeys, function* ({ error }) {
            yield message.error(error.message);
        });
    };
}

export function* showBatchImportModalError(error, headerLineCount, titleInPlural) {
    const dataSource = [];

    if (error.message && !error.errors) {
        yield message.error(error.message);
        return; // If it's just an error message, eg from status code 400, we just show that.
    }

    Object.keys(error.errors).forEach(key => {
        const [, rowStr] = key.split('.');
        const row = Number(headerLineCount) + Number(rowStr) + 1;

        const errorMessage = error.errors[key] || [];

        dataSource.push({
            row,
            error: errorMessage.length > 1 ? errorMessage.map(e => <div>{e}</div>) : errorMessage[0],
        });
    });

    const columns = [{
        title: t`Line`,
        dataIndex: 'row',
        key: 'row',
        align: 'right',
        width: 65,
    }, {
        title: t`Error Message`,
        dataIndex: 'error',
        key: 'error',
    }];

    yield Modal.error({
        title: t`Import ${capitalize(titleInPlural)} Error`,
        width: 680,
        content: (
            <div>
                <div style={{ marginBottom: 8 }}>
                    {t`The following errors were encountered while importing ${titleInPlural}. Please fix them before proceeding:`}
                </div>
                <div style={{maxHeight: '50vh', overflowY: 'auto'}}>
                    <Table
                        rowKey={(_, index) => index}
                        size="small"
                        columns={columns}
                        pagination={false}
                        dataSource={dataSource}
                        scroll={{ x: "max-content" }}
                    />
                </div>
            </div>
        ),
    });
}
